import { AboutOne } from "../../components/About/AboutOne";
import { HomeCertificatesSection } from "../../components/About/HomeCertificatesSection";
import { AboutTwo } from "../../components/About/AboutTwo";
import { BrandOne } from "../../components/Brand/BrandOne";
import { ContactAreaOne } from "../../components/ContactAreas/ContactAreaOne";
import { CounterAreaOne } from "../../components/CounterAreas/CounterAreaOne";
import { FaqAreaOne } from "../../components/FaqAreas/FaqAreaOne";
import { FeatureOne } from "../../components/Features/FeatureOne";
import { PecHomeSection } from "../../components/Services/PecHomeSection";
import { SecpHomeSection } from "../../components/Services/SecpHomeSection";
import { ServiceOne } from "../../components/Services/ServiceOne";
import { SliderAreaOne } from "../../components/SliderAreas/SliderAreaOne";
import { TeamAreaOne } from "../../components/TeamAreas/TeamAreaOne";
import { TestimonialAreaOne } from "../../components/TestimonialAreas/TestimonialAreaOne";
import { Layout } from "../../layouts/Layout";

const HomeFive = () => {
  return (
    <Layout
      header={1}
      seo={{
        title: "Business Consultants in Islamabad, Pakistan",
        description:
          "Zawix Business Consultants provides company registration, tax, audit, PEC, AEDB/PPIB, chamber, and compliance services in Islamabad and across Pakistan.",
      }}
    >
      {/* banner-area */}
      <SliderAreaOne />

      {/* about-area */}
      <AboutOne />

      {/* features-area */}
      <FeatureOne />

      {/* about-area */}
      <AboutTwo />

      {/* services-area */}
      <ServiceOne />

      {/* secp highlight */}
      <SecpHomeSection />

      {/* pec highlight */}
      <PecHomeSection />

      {/* certificates */}
      <HomeCertificatesSection />

      {/* counter-area */}
      <CounterAreaOne />

      {/* faq-area */}
      <FaqAreaOne />

      {/* team-area */}
      <TeamAreaOne />

      {/* review-area */}
      <TestimonialAreaOne />

      {/* contact-area */}
      <ContactAreaOne />

      {/* brand-area */}
      <BrandOne />
    </Layout>
  );
};

export default HomeFive;
